import type { HTMLAttributes, ReactNode } from "react";

export interface DetailListProps extends HTMLAttributes<HTMLDListElement> {
  children: ReactNode;
}

export function DetailList({ children, className, ...rest }: DetailListProps) {
  const classes = ["qr-detail-list"];
  if (className) classes.push(className);

  return (
    <dl className={classes.join(" ")} {...rest}>
      {children}
    </dl>
  );
}

export interface DetailItemProps extends HTMLAttributes<HTMLElement> {
  label: ReactNode;
  children: ReactNode;
}

// Fragment döner (sarmalayıcı element yok): <dt>/<dd> DetailList'in doğrudan
// çocukları olmalı, aksi halde qr-detail-list'in grid satır eşleştirmesi
// bozulur.
export function DetailItem({
  label,
  children,
  className,
  ...rest
}: DetailItemProps) {
  const classes = ["qr-detail-value"];
  if (className) classes.push(className);

  return (
    <>
      <dt className="qr-detail-term">{label}</dt>
      <dd className={classes.join(" ")} {...rest}>
        {children}
      </dd>
    </>
  );
}
